import { Box, Button, NavList } from '@deckee/deck-hand';
import React, { FC } from 'react';
import { Vessel } from '../../../../services/store/modules/vessels/models';
import VesselListItem from './VesselListItem';

interface WatercraftSelectorSheetProps {
  vessels: Vessel[];
  onSelectVessel: (vessel: Vessel) => void;
  onAddWatercraft: () => void;
  onBackToManual: () => void;
}

const WatercraftSelectorSheet: FC<WatercraftSelectorSheetProps> = ({
  vessels,
  onSelectVessel,
  onAddWatercraft,
  onBackToManual,
}) => (
  <Box width="100%">
    {vessels.length > 0 && (
      <NavList edge grouped mb="3">
        {vessels.map((vessel) => (
          <VesselListItem
            key={vessel.id}
            vessel={vessel}
            bg="transparent"
            onClick={() => onSelectVessel(vessel)}
          />
        ))}
      </NavList>
    )}

    <Button.Group wide>
      <Button wide onClick={onAddWatercraft} type="button">
        Add new watercraft
      </Button>
      <Button
        wide
        outlined
        type="button"
        onClick={onBackToManual}
        data-testid="watercraft-adjust-manually"
      >
        Adjust manually
      </Button>
    </Button.Group>
  </Box>
);

export default WatercraftSelectorSheet;
